import DOMPurify from 'dompurify';

/**
 * @param text: string
 * @param regex: RegExp
 * @description returns matched words from a text as bold text elements
 */
export const turnToBold = (text: string, regex: RegExp) => {
  // extract all words that match with the provided regex
  const matches = text.match(new RegExp(regex, 'g'));

  // split the entire text into diferents strings to join it later with the new format
  const splittedText = text.split(new RegExp(regex));

  // Join the splittedText with bold words in between
  const formatted = splittedText.reduce((acc, cur, i) => {
    acc += matches?.[i] ? `${cur}<b>${matches[i]}</b>` : '';
    return acc;
  }, '');

  // Prepare text to recognize the html `<b>` tag and return final text
  return DOMPurify.sanitize(formatted);
};
